import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

const serializeArrayParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value];
      }
      return [key, value];
    }),
  );

export const getComponents = async (params = {}) => {
  try {
  const formattedParams = serializeArrayParams({
    page: params.page ?? 1,
    pageSize: params.pageSize ?? 25,
    search: params.search ?? '',
    assetId: params.assetId,
    'asset.group': params.assetGroupId,
    'asset.group.class': params.assetGroupClassId,
    'asset.group.manufacturer': params.assetGroupManufacturerId,
    departmentId: params.departmentIds,
    defaultcostcentre: params.defaultCostCentre,
    costResponsilityId: params.costResponsilityId,
    taskTypeId: params.taskTypeId,
    code: params.code,
    modifierCode: params.modifierCode,
    planningTask: params.planningTask,
    statutory: params.statutory,
    componentRisk: params.componentRisk,
    componentOpportunity: params.componentOpportunity,
    nextDateRange: params.nextDateRange,
    nextDateStart: params.nextDateStart,
    nextDateEnd: params.nextDateEnd,
    overdueOnly: params.overdueOnly,
    startDate: params.startDate,
    endDate: params.endDate,
    dataFilterType: params.dataFilterType,
    dataFromElement: params.dataFromElement,
    sortField: params.sortField,
    sortOrder: params.sortOrder,
      taskType: params.taskType,
      combineCycleServiceTasks: params.combineCycleServiceTasks,
      combineSuppressionTasks: params.combineSuppressionTasks,
      currentTimestamp: params.currentTimestamp ?? new Date().toISOString(),
    });
    const response = await axiosInstance.get(`${API_URL}/components`, {
      params: formattedParams,
      paramsSerializer: (queryParams) => {
        const query = new URLSearchParams();
        Object.entries(queryParams).forEach(([key, value]) => {
          if (value === undefined || value === null || value === '') {
            return;
          }
          if (Array.isArray(value)) {
            value.forEach((entry) => query.append(key, entry));
            return;
          }
          query.append(key, value);
        });
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching components:', error.response?.data || error);
    throw error;
  }
};

export const getTasksForBudget = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/components/tasks-for-budget`, payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching tasks for budget:', error.response?.data || error);
    throw error;
  }
};
